<template>
    <!-- Control buttons in the upper left corner -->
  <div style="position:absolute; left: 0.6rem; top: 4.167rem; height: 1.33rem; width: 8.33rem; z-index: 2001;
  display: flex; flex-direction: column; justify-content: center;">
    <el-button :class="['search-btn', { show: isHidden }]" id="searchButton" type="primary"  @click="clickFloatingbutton()"
               style="width: 5.33rem; font-size: 0.5rem; height: 1rem;" round>
               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                  style="fill: white; margin-right: 0.167rem; height: 0.6rem; width: 0.6rem;">
                <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
              </svg>Search</el-button>

  </div>

  <!-- Search Dialog -->
  <el-dialog v-model="dialogVisible" width="70%"
      title="Search Dialog" draggable
  >
    <el-form :model="formData" label-width="15%" v-on:submit.prevent>
      <el-form-item>
        <template v-slot:label>
          <el-tooltip
              effect="light"
              content="Input any 'Disease | Drug | Lab | Procedure' that you are interested in."
              placement="top"
          >
            <span style="display: flex; align-items: center;">Search for:
              <el-icon :size="18"><QuestionFilled /></el-icon>
            </span>
          </el-tooltip>
        </template>
        <el-input v-model="searchInput" placeholder="Disease | Drug | Lab | Procedure" clearable  @keyup.enter="clickSearch" style="width: 90%"/>
        <div style="width: 1%" />
        <el-button type="primary" :icon="Search" @click="clickSearch" style="width: 9%">Search</el-button>
      </el-form-item>

      <el-alert v-if="loadingFail" title="Network unstable. Please try again later." type="warning" center show-icon />

      <el-form-item style="width: 88%;" label="Select your targets:">
        All the terms you select will be collected as the target nodes and used as the initial state before the network expansion.
          <el-table stripe element-loading-text="Fetching Data..." v-loading="treeLoading" :data="tableData" @select="tableChange" max-height="300">
            <template #empty>
              <el-empty image-size="50" description="Data not found" />
            </template>
            <el-table-column type="selection" />
            <el-table-column property="id" label="ID" width="160px"/>
            <el-table-column
                property="desc"
                label="Term"
                show-overflow-tooltip
            />
          </el-table>

      </el-form-item>

      <el-divider  v-if="formData.nodeOfInterestIdArray.length>0 ||selectedTreeNodesSet.size>0"/>

      <!-- 选中节点的标签展示 -->
      <el-form-item v-if="formData.nodeOfInterestIdArray.length>0 ||selectedTreeNodesSet.size>0">
        <template v-slot:label>
          <el-tooltip
              effect="light"
              content="All the IDs of nodes had been selected as target nodes."
              placement="top"
          >
            <span style="display: flex; align-items: center;">Nodes of Interest:
              <el-icon :size="18"><QuestionFilled /></el-icon>
            </span>
          </el-tooltip>
        </template>
        <el-tag v-for="tag in formData.nodeOfInterestIdArray"
            :key="tag"
            class="mx-1"
            closable
            :disable-transitions="false"
            @close="deleteSelectedNodeTag(tag)"
        >{{ tag }}
        </el-tag>
        <el-check-tag v-if="formData.nodeOfInterestIdArray.length>0" :disable-transitions="false" type="danger" @click="clickClearTags">Clear Previous</el-check-tag>
        <el-tag v-for="tag in selectedTreeNodesSet"
            :key="tag"
            class="mx-1"
            :disable-transitions="false"
        >{{ tag }}
        </el-tag>
      </el-form-item>

      <!-- 规定搜索深度, 并且可以通过按钮动态调整 -->
      <el-form-item v-if="formData.nodeOfInterestIdArray.length>0 ||selectedTreeNodesSet.size>0">
        <template v-slot:label>
          <el-tooltip
              effect="light"
              content="The search depth determines how many levels of connected nodes will be displayed. When depth=1, only nodes directly connected to the center nodes will be shown. When depth=2, nodes connected to those nodes will also be included, and so on."
              placement="top"
          >
            <span style="display: flex; align-items: center;">Search Depth:
              <el-icon :size="18"><QuestionFilled /></el-icon>
            </span>
          </el-tooltip>
        </template>
        <el-input-number v-model="formData.depth" :min="1" :max="6"/>
      </el-form-item>

<!--      &lt;!&ndash; 调整搜索阈值的滚动条, 问号的信息, 建议的阈值信息 &ndash;&gt;-->
<!--      <el-form-item label="Min Threshold:" v-if="formData.nodeOfInterestIdArray.length>0 ||selectedTreeNodesSet.size>0">-->
<!--        <template v-slot:label>-->
<!--          <el-tooltip-->
<!--              effect="light"-->
<!--              content="The cosine similarity threshold between nodes; the network will only display links above this threshold. A higher threshold results in fewer displayed nodes."-->
<!--              placement="top"-->
<!--          >-->
<!--            <span style="display: flex; align-items: center;">Min Threshold:-->
<!--              <el-icon :size="18"><QuestionFilled /></el-icon>-->
<!--            </span>-->
<!--          </el-tooltip>-->
<!--        </template>-->
<!--        <el-slider v-model="formData.minThreshold" :min="0" :max="1" :step="0.01" show-input/>-->
<!--        <div v-if="thresholdInfo">{{ depthThresholdMap.get(formData.depth )}} is recommended.&ensp;</div>-->
<!--        <div v-if="thresholdInfo">Increase threshold to reduce the number of nodes.</div>-->
<!--      </el-form-item>-->

    </el-form>

    <!-- 搜索框的最下面三个按钮,  -->
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="resetDialogData" type="danger" plain
                   v-if="formData.nodeOfInterestIdArray.length>0 ||selectedTreeNodesSet.size>0">Clear Data</el-button>
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="clickConfirmDialog()"
                   v-if="formData.nodeOfInterestIdArray.length>0 ||selectedTreeNodesSet.size>0">
          Confirm
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { ElIcon, ElMessage } from "element-plus";
import {
  formData,
  depthThresholdMap,
  fullscreenLoading,
  nodeRelativeCategoryMap,
  myGraph,
  state,
  selectedCategory,
  isInView,
  calculateLabelFontSize,
  calcThresholdOfNodeToShow,
  initializeGraphData, selectedTreeNodesSet, handleNodeClick, currentData, lineOpacityCoef, selectedTreeCategorySet,
} from "../stores/globalStore";
import { calcDistFromOrig, updateNodeRelativeCategory, getNodeThreeObject, getLinkThreeObject } from "../stores/globalStore";
import axios from "axios";
import {ref} from "vue";
import {cameraFramePadding, centerNodeFontsize, graphConfig, minLinkLength} from "@/configs/graphConfig";
import {Search} from "@element-plus/icons-vue";

defineProps({
  isHidden: {
    type: Boolean,
    default: false
  }
})

// TODO: 代码简化

 // Search Results
// Search Bar
const treeLoading = ref(false); //若设置为true，则表示正在加载, 出现一个转圈的动画
const treeVisible = ref(false) //树选择器是否显示, 和加载可以同时为true, 加载未完成时, 是在树选择器的上层显示一个转圈的动画
const searchInput = ref(null) //搜索框内容
// treeData is what is shown by the tree selected
// treeSelectorVisible controls whether the tree selector will be shown
const treeData = ref([]);  // 接收搜索提交后的数据
const tableData = ref([]);  // 接收搜索提交后的数据

const loadingFail = ref(false);

const treeSelectorVisible = ref(false)   // 这个变量好像没有用到
  // For display: Binding with the Tree selector
// let selectedTreeNodesSet = reactive(new Set()); // 起始是空的, 保存选中的节点

// 4.2 点击search触发clickSearch
// 4.2.1 点击search后, 出现一个转圈的动画, 表示正在加载(修改了treeLoading和treeVisible的值)
// 4.2.2 使用异步方式(async)同步执行(await), 如果成功, 执行then, 如果失败, 执行catch
// 4.2.3 成功后, 捕获返回的数据, 命名为res, 判断为空和非空处理
// 4.2.4 然后把res内的数据处理一下, 给treedata
async function clickSearch() {

  if (!searchInput.value) {
    ElMessage.error("Please enter a valid keyword!");
    return;
  }

  treeLoading.value = true;
  treeVisible.value = true;
  loadingFail.value = false;

  var timeout = setTimeout(() => {
    if (treeLoading.value) {
      treeLoading.value = false;
      treeVisible.value = false;
      loadingFail.value = true;
    }
  }, 10000);

  // https://dev.parse-health.org/network-api/search?input=diabetes
  // https://68a3f57ec123272fb9b0dbff.mockapi.io/users
  await axios.get("https://dev.parse-health.org/kage-api/search?input=" + searchInput.value)
      // `${window.location.href}searchCUIList?keyword=`  + searchInput.value
      .then(async function (res) {
        clearTimeout(timeout);
        if (res.data.data.length == 0) {
          // Return Data is null
          ElMessage.info("No CUI or PheCode found, please modify keywords.");
          tableData.value = []
          treeLoading.value = false;
        } else {
          // Return Data is not null
          // Assign Values to Tree
          // 把selectedTreeNodesSet的数据添加到formData.nodeOfInterestIdArray中, 若数据为空不执行
          selectedTreeNodesSet.forEach((item) => {
            formData.nodeOfInterestIdArray.push(item)
          })

          // 先把formData.nodeOfInterestIdArray的数据去重, 再转回数组格式, 但selectedTreeNodesSet本来就是set, 所以这段代码可能是多余的
          formData.nodeOfInterestIdArray = Array.from(new Set(formData.nodeOfInterestIdArray))

          selectedTreeNodesSet.clear();  // 清空该值

          // 把搜索结果(res.data.data)的数据转成了数组, 然后这个新数组把res.data.data的数据处理成了三个字段, 变成treedata
          // Data update issue, wait for the display component to update the data
          treeData.value = Array.from(res.data.data, item => ({
            // Similar to a stream, the data returned by the background is processed
            value: item.id, // Selected item binding value
            label: item.id + " ( " + item.desc + ")",// Text displayed on the label
            leaf: false,// Is it a leaf node
          }))

          tableData.value = res.data.data;

          treeLoading.value = false;
          treeSelectorVisible.value = true;
        }
      })
      .catch(error => {
        ElMessage.error("Failed request：" + error)
      })
}

function tableChange(data, row){
  console.log(row)
  if (selectedTreeNodesSet.has(row.id)) {
    selectedTreeNodesSet.delete(row.id)
    selectedTreeCategorySet.delete(row.category);
  } else {
    selectedTreeNodesSet.add(row.id);
    selectedTreeCategorySet.add(row.category);
  }
}
// 4.4.2 当前查询出的集合中, 有任一复选框被选中或取消, 都会触发这个函数
// function treeCheckMethod(data, selected){
//   console.log(data,selected)
// }

// Tag Operations
// 4.5 删除选中节点的标签
function deleteSelectedNodeTag(tag){
  let temp = new Set(formData.nodeOfInterestIdArray)
  temp.delete(tag);
  selectedTreeNodesSet.delete(tag);
  formData.nodeOfInterestIdArray = Array.from(temp);
}

// 4.6 清除选中节点, 看起来没有用到
function clickClearTags() {
  formData.nodeOfInterestIdArray.length = 0;
}

// 4.7 清除树选择器相关数据, 点击confirm时调用的函数会触发
// Clear Tree Selector Related Data
function resetDialogTreeSelector(){
  searchInput.value = null;
  treeData.value = [];
  treeVisible.value = false;
  selectedTreeNodesSet.clear();
}

// Clear Dialog Data
// 4.8 清除搜索框数据
function resetDialogData(){
  searchInput.value = null;
  formData.nodeOfInterestIdArray.length = 0;
  formData.depth = 2;
  formData.minThreshold = depthThresholdMap.get(formData.depth);
  treeVisible.value = false;
  treeData.value = [];
  selectedTreeNodesSet.clear();
  // thresholdInfo.value = false;
}


// el-tree标签的配置, 和treedata配合使用, treeconfig的值对应treedata中的键
// let treeConfig = reactive({
//   label: 'label',
//   isLeaf: 'leaf',
// })


// Dialog related logic
// 4.1 搜索对话框状态(树选择器)
let dialogVisible = ref(false) // 搜索框的显示和隐藏
function clickFloatingbutton(){
  dialogVisible.value = true
}

// 5.2 点击confirm, 触发clickConfirmDialog, 进行结果的处理和更新3d图
async function clickConfirmDialog() {
  // Close Dialog, Show loading
  dialogVisible.value = false;
  fullscreenLoading.value = true;
  selectedTreeNodesSet.forEach((item) => {
    formData.nodeOfInterestIdArray.push(item)
  })
  formData.nodeOfInterestIdArray = Array.from(new Set(formData.nodeOfInterestIdArray))
  state.selectedIdSet.clear();      // 清空selectedIdSet
  state.selectedIdSet = new Set(formData.nodeOfInterestIdArray);  // 重新赋值selectedIdSet

  state.selectedCategoriesSet.clear();
  let selectedCategoryArray = [];
  selectedTreeCategorySet.forEach((item) => {
    selectedCategoryArray.push(item)
    state.selectedCategoriesSet.add(item)
  })
  console.log(state.selectedCategoriesSet)
  tableData.value = []

  // let hasRenderedColorgroups = false;

  // 生成，分隔的查询字符串
  let queryStr = '';
  let queryList = Array.from(formData.nodeOfInterestIdArray)
  for (let i = 0; i < queryList.length; i++) {
    queryStr = queryStr + queryList[i]
    if (i !== queryList.length - 1) {
      queryStr = queryStr + ','
    }
  }

  await axios.get("https://dev.parse-health.org/kage-api/network?input=" + queryStr + "&depth=" + formData.depth) //  + "&depth=" + formData.depth
      .then(async function (res) {

        currentData.value = res.data.data;

        nodeRelativeCategoryMap.value = updateNodeRelativeCategory(currentData.value)

        currentData.value.nodes.forEach(n => {
          if (state.selectedIdSet.has(n.id)) {
            state.selectedCategoriesSet.add(n.category)
          }
        });

        // let colorGroup = res.data.data.colorgroup
        const initialData = initializeGraphData(currentData.value);

        myGraph.graphData(initialData);

        myGraph
            .nodeThreeObject(node=>{
              return getNodeThreeObject(node, state.selectedIdSet, 0)
            })
            .linkThreeObject(link => {
              return getLinkThreeObject(link, formData.minThreshold, lineOpacityCoef.value/200);
            })
            .nodeVal(node=>{ // 根据节点连接数决定节点大小(视觉上的), 和节点的质量, 但由于使用了自定义3D对象, 所以只对结点力相关的计算产生影响, 质量越大越稳定
              return node.degree
            })
            .linkLabel(graphConfig.interaction.link.tooltipFormat)
            .warmupTicks(35)
            .cooldownTicks(100)
            .onNodeClick((node) => handleNodeClick(node))
            .d3Force('link')
            // 调整links长度, 通过设置最小links长度避免挤成一坨
            .distance(link => {
              if (link.length) {
                return link.length
              } else {
                const minLength = minLinkLength; // 设置最小链接长度
                const calculatedLength = 100 * (1 - Math.log(link.weight + 1) / Math.log(10));
                return Math.max(calculatedLength, minLength); // 返回计算长度和最小长度中的较大值
              }
            })

        // Clear Tree Selector Related Data
        resetDialogTreeSelector();
        let camera = myGraph.cameraPosition();
        // setTimeout(()=>{
        //   myGraph.linkThreeObject(link => {
        //     return getLinkThreeObject(link, 0.5, lineOpacityCoef.value/200);
        //   })
        //   fullscreenLoading.value = false;
        // },20)
        setTimeout(()=>{
          myGraph.zoomToFit(600, cameraFramePadding);

          // 进行标签显示初始化
          const nodes = myGraph.graphData().nodes;
          // const selectedCategorySet = new Set(selectedCategory.value);

          // 初次渲染时固定节点位置
          nodes.forEach(node => {
            node.fx = node.x;
            node.fy = node.y;
            node.fz = node.z;
          });

          myGraph.nodeVisibility(node => {
            return !(node.category === 'colorgroup');
          }).linkVisibility(link=> {
            return !(link.source.category === "colorgroup" || link.target.category === 'colorgroup');
          })

          updateLabelVisibility()

          setTimeout(()=>{

            state.cameraOrigDist = calcDistFromOrig(camera.x,camera.y,camera.z);
            // myGraph.linkThreeObject(link => {
            //   return getLinkThreeObject(link, 0.5, 0.05);
            // })
            myGraph.linkThreeObject(link => {
              return getLinkThreeObject(link, formData.minThreshold, lineOpacityCoef.value/200);
            })


          },1005)
        },100)

        setTimeout(()=>{
          fullscreenLoading.value = false;
          myGraph.zoomToFit(600, cameraFramePadding);
        },200)

        if(res.data.code==201){
          ElMessage.info({duration:10*1000,message:res.data.msg})
        }
      })
      .catch(error => {
        ElMessage.error("Failed request:" + error)
      })
}

function updateLabelVisibility(){

  const camera = myGraph.cameraPosition();
  const nodes = myGraph.graphData().nodes;
  const selectedCategorySet = new Set(selectedCategory.value);

  nodes.forEach(node => {
    if (node.nodeLabel && node.nodeLabel.element &&
        isInView(myGraph, node) &&
        selectedCategorySet.has(node.category)) {
      // 计算并更新字体大小
      if ( state.selectedIdSet.has(node.id)) {
        node.nodeLabel.element.style.fontSize = `${centerNodeFontsize}px`;
        node.nodeLabel.element.style.color = `#39b5f4`;
      } else {
        const fontSize = calculateLabelFontSize(node, camera);
        node.nodeLabel.element.style.fontSize = `${fontSize}px`;
      }
    }
  });

  let VisThreshold = calcThresholdOfNodeToShow(myGraph);
  if (VisThreshold === 0) {
    VisThreshold = 12;
  }

  // 更新节点的显示状态
  myGraph.nodeThreeObject(node => {
    return getNodeThreeObject(node, state.selectedIdSet, VisThreshold);
  });
}


// 4.4 搜索阈值提示信息
// var thresholdInfo = ref(false);
// 4.4 监听搜索深度变化
// 4.4.1 若搜索深度变化, 从深度阈值映射表中(depthThresholdMap)获取对应的深度阈值, 更新给formdata的深度阈值, 然后令提示显示(true)
// 4.4.2 deep:true(深度监听) 默认情况下, 除非某个对象的所有属性都变化, 才会触发监听, 深度监听就是某个对象的某个属性变化, 也会触发这个watch
// watch(() => formData.depth,()=>{
//   formData.minThreshold = depthThresholdMap.get(formData.depth);
//   thresholdInfo.value = true;
// },{deep:true,})


</script>

<style scoped>

.search-btn {
  /* 隐藏时位移到屏幕外 */
  transform: translateX(-6.67rem);
  transition: transform 0.3s ease;
}

.search-btn.show {
  transform: translateX(0);
}


svg{
  width: 100%;
  height: 100%;
}

.el-scrollbar .el-scrollbar__wrap {
  border: 0.5px;
  border-color: #dcdfe6;
  border-style: solid;
}
</style>

